import { createClient } from '@supabase/supabase-js';

// HTTPS Enforcement in Production
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined' && window.location.protocol !== 'https:') {
  window.location.replace(window.location.href.replace('http:', 'https:'));
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
